import { useEffect, useMemo, useState } from "react";
import { ticketsDataDTO } from "./helpers";
import {
  statusAuthorizedRoles,
  tickets,
  ticketStatusConversion,
} from "./constants";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
// import { Ticket } from "./ticket";
import styles from "./styles.module.scss";
import { CaseCard } from "./case-card";
import { UseApiCallV2, UseLazyApiCallV2 } from "hooks";
import { useCurrentUserContext } from "providers";
import { Dropdown, Input, message, Popover, Spin } from "antd";
import { useLanguageTranslator } from "hooks/use-language-translator";
import {
  DeleteIconRed,
  MoveToLeftIcon,
  MoveToRightIcon,
  RenameIcon,
  ThreeDotIcon,
  ThreeDotIconBlack,
} from "icons";
import { ColumnCardUpdate } from "./case-card/components/column-card-update";
import { ConfirmationPopUp } from "pages/cases-detail/components/modals";
import { ConditionalRenderer } from "components";
import { DropableColumn } from "./dropable-column";

export const CasesCardsLayout = ({
  casesData,
  refetchCases,
  casesLoading,
  employees,
  employeesLoading,
  columnsOrder,
  columnsStatusData,
  refetchStatuses,
}) => {
  const { user } = useCurrentUserContext();
  const { translator } = useLanguageTranslator();
  const caseStatusColumnsTrans = translator("caseStatusColumns");
  const [data, setData] = useState({});
  const [ticketData, setTicketData] = useState({});
  const [showTicketDetailModal, setShowTicketDetailModal] = useState(false);
  const [columnName, setColumnName] = useState("");
  const [
    updateStatus,
    {
      data: updateStatusData,
      isLoading: updateStatusLoading,
      error: updateStatusErr,
    },
  ] = UseLazyApiCallV2({
    url: "/update_status",
    method: "POST",
  });

  const finalEmployees = useMemo(() => {
    return employees?.users?.map((item) => {
      return {
        label: item?.username,
        value: item?.email,
      };
    });
  }, [employees?.users]);

  useEffect(() => {
    const initialDataObj = ticketsDataDTO(casesData, columnsStatusData);

    setData(initialDataObj);
  }, [casesData, columnsStatusData]);

  const onDragEnd = (result) => {
    const { destination, source, draggableId, type } = result;

    if (!destination) return;

    // 🟦 COLUMN MOVE
    if (type === "COLUMN") {
      setData((prev) => {
        const newOrder = Array.from(prev.columnOrder);
        newOrder.splice(source.index, 1);
        newOrder.splice(destination.index, 0, draggableId);

        return {
          ...prev,
          columnOrder: newOrder,
        };
      });
      return;
    }

    // 🟩 TICKET MOVE (your existing logic)
    const sourceStatus = source.droppableId;
    const status = destination.droppableId;

    handleUpdateStatus({
      ticketId: draggableId,
      value: status,
    });
  };

  async function handleUpdateStatus({ value, ticketId }) {
    try {
      const res = await updateStatus({
        params: {
          case_id: ticketId,
          statusId: value,
          loggedUser: user?.email,
        },
      });
      if (res?.status === "SUCCESS") {
        message.success(res?.message);
        await refetchCases();
      } else {
        message.error(translator("somethingWentWrong"));
      }
    } catch (error) {
      console.log({ error });
    }

    // const endPoint = "/update_ticket_status";
    // try {
    //   const res = await updateTicketStatus({
    //     url: endPoint,
    //     params: {
    //       ticket_id: ticketId,
    //       status: value,
    //     },
    //   });
    //   if (res) {
    //     const { success, message: apiMessage } = res || {};
    //     refetchTicketsData();
    //     return success
    //       ? message.success(apiMessage)
    //       : message.error(apiMessage);
    //   }
    // } catch (error) {
    //   console.error("Error:", error);
    // }
  }
  function handleCloseModal() {
    setTicketData({});
    setShowTicketDetailModal(false);
  }
  function handleOpenModal() {
    setShowTicketDetailModal(true);
  }
  const loading = employeesLoading;

  let updateOptions = [
    {
      label: "Rename Category",
      key: "rename",
      icon: <RenameIcon />,
    },
    {
      label: "Move Column Left",
      key: "left",
      icon: <MoveToLeftIcon />,
    },
    {
      label: "Move Column Right",
      key: "right",
      icon: <MoveToRightIcon />,
    },
    {
      label: "Delete Category",
      key: "delete",
      icon: <DeleteIconRed />,
    },
  ];

  updateOptions = updateOptions?.map((item) => ({
    ...item,
    label: caseStatusColumnsTrans?.[item.key],
  }));

  useEffect(() => {
    if (data?.columnOrder?.length > 0) {
      localStorage.setItem(
        "statusColumnsOrder",
        JSON.stringify(data?.columnOrder),
      );
    }
  }, [data?.columnOrder]);

  return (
    <Spin spinning={loading}>
      <div className={styles.columnsContainer}>
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable
            droppableId="all-columns"
            direction="horizontal"
            type="COLUMN"
          >
            {(provided) => (
              <div
                ref={provided.innerRef}
                {...provided.droppableProps}
                className={styles.columnsContainer}
              >
                {data?.columnOrder?.map((columnId, index) => {
                  const column = data?.columns[columnId];

                  const tickets = column?.ticketIds?.length
                    ? column?.ticketIds.map(
                        (ticketId) => data.tickets[ticketId],
                      )
                    : [];

                  return (
                    <Draggable
                      draggableId={column?.id}
                      index={index}
                      key={column?.id}
                    >
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          style={{
                            ...provided.draggableProps.style, // 👈 REQUIRED
                            minWidth: 400,
                          }}
                        >
                          <DropableColumn
                            dragHandleProps={provided.dragHandleProps}
                            column={column}
                            columnId={columnId}
                            columnName={columnName}
                            styles={styles}
                            tickets={tickets}
                            handleUpdateStatus={handleUpdateStatus}
                            updateOptions={updateOptions}
                            setColumnName={setColumnName}
                            handleOpenModal={handleOpenModal}
                            setTicketData={setTicketData}
                            finalEmployees={finalEmployees}
                            refetchCases={refetchCases}
                            refetchStatuses={refetchStatuses}
                            setData={setData}
                          />
                        </div>
                      )}
                    </Draggable>
                  );
                })}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    </Spin>
  );
};
